import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const knowledgeHubCategoryRoute: InvariantJiraRoute = {
	name: 'knowledge-hub-category',
	path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId',
};
